import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import {
  useAbortedEffect,
  useSearch,
  useTable,
  usePop,
} from "../../../components/hooks";
import { KnowledgeAPI } from "../../../axios/api";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import ModulePopKnowledgeDetail from "./popDetail";
import { option_category_obj, option_link_type } from "../../../service/option";
import { system_table } from "../../../service/system";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";

export default function MemberKnowledgeType() {
  const dispatch = useDispatch();
  const route_params = useParams();
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "知識", href: "/member/knowledge" },
    { key: 3, label: option_category_obj.knowledge[route_params.type]?.label },
  ];
  const [reload, setReload] = useState({ list: false });
  const {
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  // 篩選條件
  const defaultFilter = {
      page: 1,
      size: system_table.size,
      url_type: null,
    },
    pagePath = "/knowledge";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "detail",
      title: () => "",
      isOpen: false,
    },
  ]);

  useEffect(() => {
    const action = ({ startIndex, rows }) => {
      let temp = {
        ...search,
        page: Math.floor(startIndex / rows) + 1,
        size: rows,
      };
      setFilterData(temp);
      setSearch(temp);
    };
    setPageAction(
      () =>
        ({ startIndex, rows }) =>
          action({ startIndex, rows })
    );
  }, [search]);

  useAbortedEffect(
    (signal) => {
      if (!reload.list) return;

      dispatch(setProgress(true));

      let params = {
        type: option_category_obj.knowledge[route_params.type].type,
        ...search,
      };

      KnowledgeAPI.getKnowledgesDataByType({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          // data = data.map((item) => ({
          //   title: item.question,
          //   content: item.answer,
          // }));
          setTbTotalRecords(total);
          setTbData(data);
          setReload((state) => ({ ...state, list: false }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  const likeHandler = ({ data }) => {
    dispatch(setProgress(true));

    let promise;
    if (data.knowledgesLikes) {
      // 刪除
      promise = KnowledgeAPI.deleteKnowledgesLikes({
        data: {
          id: data.knowledgesLikes.id,
        },
      });
    }
    {
      // 新增
      promise = KnowledgeAPI.setKnowledgesLikes({
        data: {
          kid: data.id,
        },
      });
    }

    promise.then((result) => {
      let { Response, data, total, message } = result;

      if (Response === 1) {
        setReload((state) => ({ ...state, list: true }));
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  useEffect(() => {
    setTbColumns([
      {
        field: "title",
        header: "標題",
        className: "flex-grow-1 w-8rem",
      },
      {
        field: "id",
        header: "",
        className: "w-8rem",
        body: (data) => (
          <>
            <div className="flex align-items-center">
              <Button
                className="p-button-main p-button-sm mr-2"
                type="button"
                label={data.is_read === 0 ? "未讀" : "已讀"}
                onClick={() => openPop({ type: "detail", data })}
              />

              {data.is_read === 1 && (
                <span className="ml-2">
                  <i
                    className={classNames("pi cursor-pointer", {
                      "pi-heart": !data.knowledgesLikes,
                      "pi-heart-fill text-red-400": data.knowledgesLikes,
                    })}
                    onClick={() => likeHandler({ data })}
                  ></i>
                </span>
              )}
            </div>
          </>
        ),
      },
    ]);
  }, []);

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle
        data={{
          title: option_category_obj.knowledge[route_params.type]?.label,
        }}
      />

      {renderSearchWrap({
        isShow: false,
        template: (
          <>
            <div className="col-12 md:col-4 xl:col-3 flex align-items-start flex-column mt-2 md:mt-0">
              <label
                htmlFor="username"
                className="w-4rem white-space-nowrap text-left mb-1"
              >
                網址類型
              </label>
              <Dropdown
                name="url_type"
                className="w-full"
                value={filterData.url_type}
                onChange={(e) => changeFilter(e)}
                options={option_link_type}
                showClear={true}
              />
            </div>
            <div
              className={classNames(
                "col-12 md:col-8 xl:col-9 flex align-items-end mt-2 md:mt-0"
              )}
            >
              <Button
                className="p-button-info w-auto ml-auto md:ml-0 md:mt-0 px-3"
                type="button"
                icon="pi pi-search"
                label="查詢"
                onClick={() => {
                  setSearch({
                    ...filterData,
                    page: 1,
                  });
                  setTbFirstIndex(0);
                }}
              />
            </div>
          </>
        ),
      })}

      {renderTable({
        className: "mt-2",
        options: { scrollable: true, scrollDirection: "both" },
      })}

      {renderDialog({
        className: classNames("w-11"),
        onHide: () => {
          if (popOption.data.is_read === 0)
            setReload((state) => ({ ...state, list: true }));
          closePop({ type: popOption.type });
        },
        children: (
          <>
            {isPop.detail?.isOpen && (
              <ModulePopKnowledgeDetail
                prePopOption={popOption}
                closePrePop={closePop}
                setPreReload={setReload}
              />
            )}
          </>
        ),
      })}
    </>
  );
}
